import { PropsWithChildren } from 'react';
import { Button } from 'src/modules/common/components/Button/Button';
import { MoreIcon } from 'src/modules/common/icons/MoreIcon';

type Props = PropsWithChildren<{
    onClick: () => void;
}>;

export const CalculatorInputRow = ({ children, onClick }: Props) => (
    <div className="vss-calculator-input-row">
        {children}

        <Button
            data-testid="calculator-input-row-button"
            className="vss-calculator-input-row__button"
            iconOnly={true}
            size="lg"
            onClick={onClick}
        >
            <MoreIcon/>
        </Button>
    </div>
);
